export { useStaticData } from './hooks';
